import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
import { ISLMap } from 'src/app/types/@types/sl-map';

@Injectable({
	providedIn: 'root'
})
export class ModalResultStyleService {
	public request$: Subject<any> = new Subject();
	constructor() { }

	GetStyles(handler: DictHandler, slMap: ISLMap, optStyle: string = '') {
		this.request$.next({ handler: (handler), map: slMap, type: optStyle });
	}
}
